<template>
<div class="popup" v-cloak v-show="removeAllShow">
     <div class="content" id="twoStepverification">
           <div class="title">
                 <span v-if="removeAll">{{$t('language.twoStepverification.removeAll')}}</span>
                 <span v-else>{{$t('language.twoStepverification.removeMethod')}}</span>
                 <div class="icon white-close dialog-close" @click="closePage()"></div>
           </div>
           <div class="step-body-content">
                <div style="float:left;height:60Px;fontSize:14Px;textAlign:center;lineHeight:20Px;color:#6f7886;">
                <span v-if="removeAll">{{$t('language.twoStepverification.lostAccess')}}</span>
                <span v-else>{{$t('language.twoStepverification.removeMethodSure')}}</span> 
                </div>
                <div class="step-footer">
                     <button class="re-cancel" @click="closePage()">{{$t('language.twoStepverification.cancel')}}</button>
                     <button class="re-bind" @click="removeSubmit()">{{$t('language.leftBanner.remove')}}</button>
                    
                </div>
           </div>
     </div>
</div>
</template>

<script>
import areaCodeUtil from "../../../js/workspace/area_code_utils.js";
import commonUtils from "@/js/workspace/common_util.js";
export default {
    data() {
        return {
            cornet:'86',
            user:commonUtils.getUser(),
            removeAllShow:false,
            removeAll:true,//标识是否移除所有设备操作
            phoneNumber:null,
            email:null
        }
    },
    methods: {
        closePage(){
            this.removeAllShow=false;
        },
        getVerify(){
               let that=this;
               this.Utils.doDualVerifyRequest('get',{userId:this.user.id}).then(res=>{
               //如果是非法的账号
                   if(res.devices[0] && res.devices[0].indexOf("-")!=-1){
                   let index = res.devices[0].indexOf("-");
                   that.$parent.$refs.updateVerificationDialog.cornet = res.devices[0].substring(0,index);
                   res.devices[0] = res.devices[0].substring(index+1);
                }
                that.$parent.$refs.updateVerificationDialog.emialValue=res.devices[1];
                that.$parent.$refs.updateVerificationDialog.phoneValue=res.devices[0];
                if(!that.$parent.$refs.updateVerificationDialog.phoneValue){
                    that.$parent.$refs.updateVerificationDialog.txtShow=false;
                }
                if(!that.$parent.$refs.updateVerificationDialog.emialValue){
                     that.$parent.$refs.updateVerificationDialog.emialShow=false;
                }
                that.$parent.$refs.updateVerificationDialog.updateVerifiShow=true;
                that.$parent.$refs.updateVerificationDialog.verificationStatus=res.status;
            });
        },
        removeSubmit(){
        //to do执行移除所有设备操作
        let data;
        let that=this;
        this.user = commonUtils.getUser();
        if(this.phoneNumber){
           if(this.phoneNumber.indexOf("-")!=-1){
                   let index = this.phoneNumber.indexOf("-");
                   this.cornet = this.phoneNumber.substring(0,index);
                   this.phoneNumber = this.phoneNumber.substring(index+1);
           }
        }
        if(!this.removeAll){
            if(this.email){
                data={
                    userId:this.user.id,
                    email:this.email
                  }
            }else{
                data={
                    userId:this.user.id,
                    phoneNumber:this.phoneNumber,
                    cornet:this.cornet,
                  }
            }
            this.Utils.doDualVerifyRequest('remove',data).then(res=>{
            if(res.status==200){
               that.getVerify();
               that.closePage(); 
                 that.$toast({
                        text: that.$t('language.twoStepverification.trustedDevice'),
                        type: 'success',
                        idValue: "rightContBan"
                        });
                    return false;
            }
        })
        }else{
            if(this.email && this.phoneNumber){
                data={
                    userId:this.user.id,
                    phoneNumber:this.phoneNumber,
                    cornet:this.cornet,
                    email:this.email
                  }
            }
            if(this.email && !this.phoneNumber){
                data={
                    userId:this.user.id,
                    email:this.email
                  }
            }
            if(!this.email && this.phoneNumber){
                data={
                    userId:this.user.id,
                    phoneNumber:this.phoneNumber,
                    cornet:this.cornet,
                  }
            }
            if(!this.email && !this.phoneNumber){
                 data={
                     userId:this.user.id
                 }
            }
        this.Utils.doDualVerifyRequest('remove_trusted',data).then(res=>{
            if(res.status==200){
               that.getVerify();
               that.closePage(); 
                that.$toast({
                        text: that.$t('language.twoStepverification.trustedDevice'),
                        type: 'success',
                        idValue: "rightContBan"
                        });
                    return false;
            }
        })
        }
       
        },
      
      
   },

}

</script>

<style>
#twoStepverification{
    width: 500Px;
    height: 200Px;
}
.step-body-content{
    width: 100%;
    height: calc(100% - 40Px);
    box-sizing: border-box;
    padding: 30Px 30Px 10Px 30Px;
}
.step-footer{
   float: left;
   height: calc(100% - 60Px);
   width: 100%;
    display: flex;
  align-items: center; /*定义body的元素垂直居中*/
  justify-content: center; /*定义body的里的元素水平居中*/
}
.re-bind,.re-cancel{
    min-width: 110Px;
    
}
.re-cancel{
    margin-right: 40Px;
}
.re-cancel,.re-cancel:hover{
    background: #fff;
    color: #5562b4;
    border: 1Px solid #b3bcf6;
}
</style>


// WEBPACK FOOTER //
// src/components/popup/personal_center_popups/remove_all_devices_popop.vue